import { useMutation } from '@tanstack/react-query';

import { type CreateCompetition } from '@app/client/common/structs';
import { callCreateCompetition } from '@app/client/resources/admin/fantasy/competitions';
import { WISHLIST_SUMMARY_CACHE } from '@app/client/resources/fantasy';
import { formattedPostDate } from '@app/helpers';

import { useQueryInvalidation } from '../../../reactQuery';

export const DUPLICATE_DATE_INCREMENT = 2;
export const ROUNDUP_EMAIL_FREQ_DAYS = 1;

export const formatCompetitionData = (oldData: CreateCompetition) => {
    const value = { ...oldData };

    // TODO check apparently these are required?
    value.min_collection_count = value.min_collection_count || 3;

    value.submission_starts_at = formattedPostDate(value.submission_starts_at);
    value.submission_ends_at = formattedPostDate(value.submission_ends_at);
    value.published_at = formattedPostDate(value.published_at);
    value.ends_at = formattedPostDate(value.ends_at);
    value.max_user_submissions = 999999999999999;
    value.marketing_email_frequency_sec = ROUNDUP_EMAIL_FREQ_DAYS * 60 * 60 * 24;
    value.referral_max_per_user = 5;
    value.referee_payout = 10000;
    value.referrer_payout = 10000;

    // TODO check if we need to add a flag
    value.multigame = true;

    return value;
};

export const useCreateCompetition = () => {
    const invalidateWishlists = useQueryInvalidation(WISHLIST_SUMMARY_CACHE);
    return useMutation({
        mutationFn: (value: CreateCompetition) => callCreateCompetition({ value: formatCompetitionData(value) }),
        onSuccess: invalidateWishlists,
    });
};
